import { useFormContext } from 'react-hook-form'

import { spreadsheetFileTypes } from '@fortem-monorepo/constants'
import { FileUploadInput } from '@fortem-monorepo/react-ui'
import { SelectInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from './AddUploadTrackEntryForm.schema'

export interface AddUploadTrackEntryFormFieldsProps {}

export const AddUploadTrackEntryFormFields: React.FC<AddUploadTrackEntryFormFieldsProps> = ({}) => {
  const { setValue, control, register } = useFormContext<SchemaType>()

  return (
    <div className={'flex flex-col gap-4'}>
      <FormField
        name="update_type"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>Update Type</FormLabel>
              <SelectInput
                size={'sm'}
                className={'w-full'}
                value={value as string}
                onValueChange={(v) =>
                  setValue('update_type', v as SchemaType['update_type'], { shouldValidate: true })
                }
                options={[
                  { label: '1. Create Only If No Existing Data Points', value: 'create' },
                  { label: '2. Complete Missing Data Points', value: 'complete' },
                  { label: '3. Override Overlapping Data Points', value: 'override' },
                  { label: '4. Replace Existing Prices', value: 'replace' },
                ]}
              />
            </FormItem>
          )
        }}
      />
      <FormField
        name="files"
        control={control}
        render={({ field: { value } }) => {
          return (
            <FormItem>
              <FormLabel>File</FormLabel>
              <FileUploadInput
                files={value}
                accept={spreadsheetFileTypes.join(',')}
                setValue={(files) => setValue('files', files, { shouldValidate: true })}
                {...register('files')}
              />
            </FormItem>
          )
        }}
      />
    </div>
  )
}
